import React, { PropsWithChildren } from 'react';
import { useAppView } from '../../../contexts/AppViewContext';

export const SectorPanel = ({
  id,
  children,
}: PropsWithChildren<{ id: OperatorType }>) => {
  const appView = useAppView();

  if (id !== appView.pending.sector) return null;
  return (
    <ul className="w-full bg-background-dark text-white overflow-y-auto max-h-[calc(100dvh-200px)] space-y-2 p-2">
      {children}
    </ul>
  );
};
